/* TT 18 OCT - SWIPE DOWN TO CLOSE THE PHONE SHEETS (Filters & Sort, Quick Buy, Back in Stock, Account,
   and from Oct 20 every .tt-drw drawer: Back in Stock, Pick Up In Store).
   Phones only (under 700px), where these rise from the bottom. The × still closes them too.
   The sheet follows the finger; let go past a short distance (or flick down) and it closes,
   otherwise it springs back. A drag only starts when the sheet's content is scrolled to the top,
   so scrolling the list never closes the sheet by accident. Nothing runs until a finger touches a sheet. */
(function () {
  if (window.ttSheetSwipe) return;
  window.ttSheetSwipe = true;

  var phone = window.matchMedia('(max-width: 699px)');
  var CLOSE_DISTANCE = 110;   // px dragged down before letting go closes it
  var CLOSE_SPEED = 0.6;      // px per ms - a quick flick closes it from any distance
  var drag = null;

  // Filters & Sort on phones: its button does a lot of work in the same tap that opens the sheet,
  // and iPhone can leave the slide-up unfinished (sheet parked at the bottom until the next touch).
  // Once that work is done, start the slide fresh from the bottom, then make sure it lands at the top.
  function watchFilters() {
    var m = document.getElementById('tt-filter');
    if (!m || m.__ttRise) return;
    m.__ttRise = true;
    var was = m.classList.contains('tt-open');
    new MutationObserver(function () {
      var now = m.classList.contains('tt-open');
      if (now === was) return;
      was = now;
      if (!now || !phone.matches) return;
      m.style.transition = 'none';
      m.style.transform = 'translateY(100%)';
      void m.offsetHeight;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          m.style.transition = '';
          m.style.transform = '';
          setTimeout(function () {
            if (drag || !m.classList.contains('tt-open')) return;
            var top = parseFloat(getComputedStyle(m).top) || 0;
            if (m.getBoundingClientRect().top > top + 2) {
              // Did not land: put it in place now.
              m.style.transition = 'none';
              void m.offsetHeight;
              requestAnimationFrame(function () { m.style.transition = ''; });
            }
          }, 450);
        });
      });
    }).observe(m, { attributes: true, attributeFilter: ['class'] });
  }
  watchFilters();
  document.addEventListener('DOMContentLoaded', watchFilters);
  // Also before any tap is handled, in case the sheet is added to the page later.
  document.addEventListener('click', watchFilters, true);

  function sheetFor(event) {
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (!el || !el.nodeType || el.nodeType !== 1) continue;
      if (el.id === 'tt-filter' && el.classList.contains('tt-open')) {
        return { kind: 'class', panel: el, scroller: el.querySelector('.ttbody'), host: el, closeBtn: '.ttclose' };
      }
      // Opened from the phone menu it slides in from the side, not up from the bottom: no swipe-down there.
      if (el.classList && el.classList.contains('tt-drw--from-menu')) return null;
      if (el.id === 'tt-account-drawer' && el.classList.contains('is-open')) {
        var acct = el.querySelector('.tt-acct__panel');
        if (acct) return { kind: 'class', panel: acct, scroller: el.querySelector('.tt-acct__body'), host: el, closeBtn: '.tt-acct__close' };
      }
      if (el.classList && el.classList.contains('tt-drw') && el.classList.contains('is-open')) {
        var drw = el.querySelector('.tt-drw__panel');
        if (drw) return { kind: 'class', panel: drw, scroller: el.querySelector('.tt-drw__body, .tt-acct__body'), host: el, closeBtn: '.tt-drw__close' };
      }
      if (el.tagName === 'QUICK-BUY-MODAL' && el.shadowRoot) {
        var content = el.shadowRoot.querySelector('[part~="content"]');
        if (content) return { kind: 'modal', panel: content, scroller: content, host: el };
      }
    }
    return null;
  }

  function scrolledToTop(sheet, event) {
    var path = event.composedPath ? event.composedPath() : [];
    // Anything that scrolls between the finger and the sheet must be at its top.
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (!el || el.nodeType !== 1) continue;
      if (el === sheet.panel) break;
      if (el.scrollHeight > el.clientHeight + 1 && el.scrollTop > 0) {
        var oy = getComputedStyle(el).overflowY;
        if (oy === 'auto' || oy === 'scroll') return false;
      }
    }
    return !sheet.scroller || sheet.scroller.scrollTop <= 0;
  }

  document.addEventListener('touchstart', function (event) {
    if (!phone.matches || event.touches.length !== 1) return;
    var sheet = sheetFor(event);
    if (!sheet) return;
    drag = { sheet: sheet, startY: event.touches[0].clientY, lastY: event.touches[0].clientY,
             lastT: Date.now(), speed: 0, active: false, event: event };
  }, { passive: true });

  document.addEventListener('touchmove', function (event) {
    if (!drag) return;
    var y = event.touches[0].clientY;
    var dy = y - drag.startY;
    if (!drag.active) {
      if (dy < 8) { if (dy < -8) drag = null; return; }
      if (!scrolledToTop(drag.sheet, drag.event)) { drag = null; return; }
      drag.active = true;
      drag.sheet.panel.style.transition = 'none';
    }
    var now = Date.now();
    drag.speed = (y - drag.lastY) / Math.max(1, now - drag.lastT);
    drag.lastY = y; drag.lastT = now;
    drag.sheet.panel.style.transform = 'translateY(' + Math.max(0, dy) + 'px)';
    if (event.cancelable) event.preventDefault();
  }, { passive: false });

  function finish() {
    if (!drag) return;
    var d = drag; drag = null;
    if (!d.active) return;
    var panel = d.sheet.panel;
    var dy = d.lastY - d.startY;
    var close = dy > CLOSE_DISTANCE || d.speed > CLOSE_SPEED;

    if (!close) {
      panel.style.transition = 'transform .25s cubic-bezier(.4,0,.2,1)';
      panel.style.transform = '';
      setTimeout(function () { panel.style.transition = ''; }, 260);
      return;
    }

    if (d.sheet.kind === 'class') {
      // Filters and Account: let the sheet's own close run, then glide on down from where the finger let go.
      var x = d.sheet.host.querySelector(d.sheet.closeBtn);
      if (x) x.click();
      panel.style.transition = '';
      requestAnimationFrame(function () { panel.style.transform = ''; });
      return;
    }

    // Quick Buy: finish the slide ourselves, then close it with its own close, out of sight.
    panel.style.transition = 'transform .22s cubic-bezier(.4,0,.2,1)';
    panel.style.transform = 'translateY(100%)';
    setTimeout(function () {
      var host = d.sheet.host;
      panel.style.visibility = 'hidden';
      host.addEventListener('dialog:after-hide', function reset() {
        host.removeEventListener('dialog:after-hide', reset);
        panel.style.visibility = ''; panel.style.transition = ''; panel.style.transform = '';
      });
      if (typeof host.hide === 'function') host.hide();
      else { var b = host.querySelector('.quick-buy-modal__mobile-close-button'); if (b) b.click(); }
    }, 230);
  }

  document.addEventListener('touchend', finish, { passive: true });
  document.addEventListener('touchcancel', finish, { passive: true });
})();
